var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{attrs:{"data-type":`empty-${_vm.item.uuid}`,"to":`/search?q=${_vm.item.name}&type=experience`}},[_vm._v("\n  Sin resultados. Presiona Enter para agregar más filtros\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }